import React from "react";
import { TextField, Button, Switch } from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import { MESSAGE_TABLE_COLUMN_KEYS } from "../../../common/constants/scheduleModule/messagesConstants.js";
import { STRINGS, SIZES, VARIANTS, BUTTON_COLORS, AUTO_COMPLETE } from "../../../common/constants/commonConstants.js";
import DialogComponent from "../../../common/components/DialogComponent.jsx";

const EditMessageModal = ({ onSave, open, selectedMessage, handleInputChange, onClose }) => {
	return (
		<>
			<DialogComponent
                open={open}
                setWidth="md"
                onClose={onClose}
                title="Edit Message"
                actions={
                    <Button
                        onClick={onSave}
                        variant={VARIANTS.CONTAINED}
                        color={BUTTON_COLORS.PRIMARY}
                    >
                        {STRINGS.SAVE}
                    </Button>
                }
            >
				<TextField
					fullWidth
					size={SIZES.SMALL}
					autoComplete={AUTO_COMPLETE.OFF}
					label="Message"
					value={selectedMessage?.campaignSchedulemsg || ""}
					onChange={handleInputChange(MESSAGE_TABLE_COLUMN_KEYS.MESSAGE)}
					multiline
					minRows={3}
				/>
				<FormControlLabel
					value="end"
					control={<Switch
							checked={selectedMessage?.Inactive === false}
							onChange={(e) =>
								handleInputChange(MESSAGE_TABLE_COLUMN_KEYS.ENABLED)({
									target: { value: !e.target.checked }
								})
							}
						/>}
					label="Enabled"
					labelPlacement="start"
					sx={{
						ml: 0,
						mt: "15px",
					}}
				/>
            </DialogComponent>
		</>
	);
};

export default EditMessageModal;